import React from 'react'
// import * as styles from './index.module.less'

export default function Replay() {
  return <div>开发中。。。。</div>
}
